class CustomEngraving2026 extends HTMLElement {
  constructor() {
    super();
    const dataNode = document.querySelector("#custom-engraving-2026-data");
    try {
      this.engravingData = dataNode ? JSON.parse(dataNode.textContent) : [];
    } catch (error) {
      console.error("Custom engraving configuration could not be parsed:", error);
      this.engravingData = [];
    }

    this.placeholderOpenEngraving = document.querySelector(
      "#custom-engraving-2026--open-engraving",
    );
  }

  connectedCallback() {
    this.placeholderOpenEngraving = document.querySelector(
      "#custom-engraving-2026--open-engraving",
    );

    const gate = window.OGEngravingExperiment;
    if (!gate) return;

    gate.whenReady(({ assignedTreatment }) => {
      if (!assignedTreatment) {
        this.setEngravingUnavailable();
        return;
      }

      this.loadProductEngravingSettings();
      this.bindEvents();
    });
  }

  bindEvents() {
    if (this.eventsBound) return;
    this.eventsBound = true;

    this.boundPdpOpen = () => {
      this.cartContext = null;
      this.loadProductEngravingSettings();
      this.openDialog();
    };
    this.locationSelect = this.querySelector("#engraving-location");
    this.boundLocationChange = () => {
      const settings = this.currentProductEngravingSettings;
      const service = settings.engravingOptions.find(
        (option) => option.engravingType === this.locationSelect.value,
      );
      if (!service) return;
      settings.engravingService = service;
      this.dispatchProductEngravingSettings(settings.currentProductInfo, service);
    };
    this.locationSelect?.addEventListener("change", this.boundLocationChange);
    this.boundCartItemAdd = this.handleCartItemAdd.bind(this);
    this.boundCartItemEdit = this.handleCartItemEdit.bind(this);

    this.placeholderOpenEngraving?.addEventListener("click", this.boundPdpOpen);
    document.addEventListener("cartItemAddEngraving", this.boundCartItemAdd);
    document.addEventListener("cartItemEditEngraving", this.boundCartItemEdit);

  }

  openDialog() {
    if (!this.isTreatmentExperience()) return;
    const dialog = document.querySelector("#custom-engraving-2026--dialog");
    if (!dialog) return;
    dialog.showModal();
    dialog
      .querySelector("#custom-engraving-2026-title")
      ?.focus({ preventScroll: true });
  }

  handleCartItemAdd(event) {
    if (!this.isTreatmentExperience() || !event.detail?.useTreatmentEngraving) return;
    const { lineItemKey, productProperties, productVariantId } =
      event.detail || {};
    const settings = this.getEngravingSettingsForVariant(productVariantId);
    if (!settings) return;

    this.cartContext = {
      lineItemKey,
      productProperties: productProperties || {},
      productVariantId,
    };
    this.applyProductSettings(settings);
    this.openDialog();
  }

  handleCartItemEdit(event) {
    if (!this.isTreatmentExperience() || !event.detail?.useTreatmentEngraving) return;
    const {
      engravingProperties,
      lineItemKey,
      productProperties,
      productVariantId,
    } = event.detail || {};
    const settings = this.getEngravingSettingsForVariant(productVariantId, engravingProperties?._engraving_type);
    if (!settings) return;

    this.cartContext = {
      isEditing: true,
      lineItemKey,
      productProperties: productProperties || {},
      productVariantId,
    };
    this.applyProductSettings(settings);
    this.openDialog();
    this.prefillTextEngraving(engravingProperties || {});
  }

  prefillTextEngraving(properties) {
    if (properties._engraving_mode && properties._engraving_mode !== "text") return;

    const options = document.querySelector(
      "custom-engraving-2026-customization-options",
    );
    const text = document.querySelector("custom-engraving-2026-text");
    const textOption = options?.querySelector(
      'input[value="engraving-text"]',
    );
    if (!options || !text || !textOption) return;

    textOption.checked = true;
    options.setCustomizationNextStep("engraving-text");
    options.resetCasebackPreview();
    options.placeholderText.style.display = "block";
    options.placeholderIcon.style.display = "none";
    text.prefillForEdit(properties);
    options.scrollToScreen("engraving-text", "auto");
  }

  isTreatmentExperience() {
    const result = window.OGEngravingExperiment?.getResult?.();
    return (
      result?.assignedTreatment === true
    );
  }

  getEngravingSettingsForVariant(productVariantId, preferredType) {
    const variantId = String(productVariantId || "");
    if (!variantId) return null;

    const engravingOptions = window.OGEngravingExperiment?.getTreatmentOptions({ variantId }) || [];
    const engravingService = engravingOptions.find((option) => option.engravingType === preferredType) || engravingOptions[0];
    if (engravingService) {
      const currentProductInfo = (
        engravingService.associatedProducts || []
      ).find((product) => (product.variantIds || [product.variantId]).some((id) => String(id) === variantId));
      if (currentProductInfo) {
        return { engravingService, engravingOptions, currentProductInfo: { ...currentProductInfo, variantId } };
      }
    }

    return null;
  }

  buildCartRequest(cartSettings, cart) {
    const sections =
      cart?.getSectionsToRender?.().map((section) => section.id) || [];
    const basePayload = {
      sections,
      sections_url: window.location.pathname,
    };

    if (this.cartContext) {
      return {
        endpoint: "cart/change.js",
        payload: {
          id:
            this.cartContext.lineItemKey ||
            this.cartContext.productVariantId,
          properties: {
            ...this.cartContext.productProperties,
            ...cartSettings.properties,
          },
          ...basePayload,
        },
      };
    }

    return {
      endpoint: "cart/add.js",
      payload: {
        items: [cartSettings],
        ...basePayload,
      },
    };
  }

  renderCartResponse(response, cart, source) {
    const parsed = {
      id:
        response.items?.[0]?.id ||
        this.cartContext?.lineItemKey ||
        this.cartContext?.productVariantId,
      sections: response.sections,
    };

    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source,
        productVariantId: parsed.id,
        cartData: parsed,
      });
    }

    cart?.renderContents?.(parsed);
    cart?.classList.remove("is-empty");
    this.cartContext = null;
  }

  loadProductEngravingSettings(newDestination = false) {
    const currentProductHandle =
      newDestination || this.getCurrentProductHandle();

    const productEngravingSettings =
      this.getProductEngravingSettings(currentProductHandle);

    if (!productEngravingSettings.length) {
      this.setEngravingUnavailable();
      return;
    }

    const currentProductInfo = this.getCurrentProductInfo(
      currentProductHandle,
      productEngravingSettings,
    );
    if (!currentProductInfo) {
      this.setEngravingUnavailable();
      return;
    }

    this.applyProductSettings({
      currentProductInfo,
      engravingOptions: productEngravingSettings,
      engravingService: productEngravingSettings[0],
    });

    this.setEngravingAvailable();
  }

  applyProductSettings(settings) {
    this.currentProductEngravingSettings = settings;
    const select = this.querySelector("#engraving-location");
    select.replaceChildren();
    settings.engravingOptions.forEach((service) => {
      const option = document.createElement("option");
      option.value = service.engravingType;
      option.textContent = service.engravingType === "sidewall" ? "Sidewall" : "Caseback";
      option.selected = service === settings.engravingService;
      select.append(option);
    });
    this.dispatchProductEngravingSettings(settings.currentProductInfo, settings.engravingService);
  }

  setEngravingAvailable() {
    if (!this.placeholderOpenEngraving) return;
    this.placeholderOpenEngraving.dataset.engravingEligible = "true";
    this.placeholderOpenEngraving.textContent = "Add Engraving";
    this.placeholderOpenEngraving.style.removeProperty("display");
  }

  setEngravingUnavailable() {
    if (!this.placeholderOpenEngraving) return;
    this.placeholderOpenEngraving.dataset.engravingEligible = "false";
    this.placeholderOpenEngraving.style.display = "none";
  }

  getCurrentProductHandle() {
    return this.getProductHandleFromUrl(window.location.href);
  }

  getProductHandleFromUrl(url) {
    try {
      const pathname = new URL(url, window.location.origin).pathname;
      return pathname.match(/\/products\/([^/]+)/)?.[1] || "";
    } catch (error) {
      console.error("Custom engraving product URL could not be parsed:", error);
      return "";
    }
  }

  getCurrentProductInfo(currentProductHandle = "", productEngravingSettings) {
    if (currentProductHandle.trim() == "" || !productEngravingSettings.length)
      return false;

    const info = productEngravingSettings
      .at(0)
      .associatedProducts.find((el) => el.handle === currentProductHandle);
    const selectedId = document.querySelector('product-form form[data-type="add-to-cart-form"] [name="id"]')?.value;
    if (info && selectedId && (info.variantIds || [info.variantId]).some((id) => String(id) === selectedId)) {
      return { ...info, variantId: selectedId };
    }
    return info;
  }

  getProductEngravingSettings(currentProductHandle = "") {
    if (currentProductHandle.trim() == "") return [];

    return window.OGEngravingExperiment?.getTreatmentOptions({ handle: currentProductHandle }) || [];
  }

  dispatchProductEngravingSettings(currentProductInfo, engravingService) {
    const customEvent = new CustomEvent("custom-engraving-2026", {
      detail: {
        currentProductInfo,
        engravingService,
      },
    });
    document.dispatchEvent(customEvent);
  }

  disconnectedCallback() {
    this.locationSelect?.removeEventListener("change", this.boundLocationChange);
    this.placeholderOpenEngraving?.removeEventListener(
      "click",
      this.boundPdpOpen,
    );
    document.removeEventListener("cartItemAddEngraving", this.boundCartItemAdd);
    document.removeEventListener(
      "cartItemEditEngraving",
      this.boundCartItemEdit,
    );
  }
}

customElements.define("custom-engraving-2026", CustomEngraving2026);
